export function switchLang(lang: string) {
  document.cookie = `NEXT_LOCALE=${lang};max-age=31536000;path=/`;
  window.location.replace(window.location.href.replace(/\/(sv|en)\//, `/${lang}/`));
}
